module.exports = __webpack_public_path__ + "img/soulehall-h-474x356.c962e126.jpg";